import { types } from "../actions";

const initialState = {
  totalEntryCount: 0,
  totalExitCount: 0,
  peopleInVenue: 0,
  netTrafficFlow: 0,
  netTrafficFlowInterval: 30,
  graphCountStart: 0,
  areas: {},
  tagData: [],
  areaTagData: [],
  graphData: [],
  exitGraphData: [],
  cameraGraphData: [],
  cameraStats: [],
  apiError: undefined,
  userRole: "",
  shouldPollForReports: false,
  resetTime:undefined,
  dropdownValue: "10800"
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {

    case types.UPDATE_REPORT_POLLING : {
      return {
        ...state,
        shouldPollForReports: action.value
      }
    };

    case types.NET_TRAFFIC_FLOW_INTERVAL: {
      return {
        ...state,
        netTrafficFlowInterval: action.intervalInSec
      }
    };

    case types.UPDATE_RESET_TIME:{
      return{
        ...state,
        resetTime:action.time
      }
    }

    case types.FETCHED_REPORTS: {
      let data = action.payload;
        return {
            ...state,
            peopleInVenue: data.peopleCount,
            totalEntryCount: data.entryCount,
            totalExitCount: data.exitCount,
            netTrafficFlow: data.netFlow,
            areas: data.areas
        }
    };

    case types.FETCHED_COUNTER_COUNT: {
      return {
        ...state,
        graphCountStart: action.count
      }
    };

    case types.FETCHED_TAGS: {
      return {
        ...state,
        tagData: action.tagData
      }
    };

    case types.UPDATE_AREA_TAGS: {
      return {
        ...state,
        areaTagData: action.tagData
      }
    };

    case types.FETCHED_GRAPH_DATA: {
      return {
        ...state,
        graphData: action.graphData
      }
    };

    case types.FETCHED_CAM_GRAPH_DATA: {
      return {
        ...state,
        cameraGraphData: action.cameraGraphData
      }
    };

    case types.FETCHED_EXIT_GRAPH_DATA: {
      return {
        ...state,
        exitGraphData: action.exitGraphData
      }
    };

    case types.FETCHED_REPORT_DETAILS: {
      return {
        ...state,
        cameraStats: action.reportDetails
      }
    };

    case types.API_ERROR: {
      return {
        ...state,
        apiError: action.value
      }
    }

    case types.DEFAULT_API_ERROR: {
      return {
        ...state,
        apiError: undefined,
        userRole: undefined
      }
    }

    case types.SET_USER_ROLE: {
      return {
        ...state,
        userRole: action.role
      }
    }

    case types.SET_DROPDOWN_VALUE:
      return {
        ...state,
        dropdownValue: action.payload
      };
    
    default:
      return state;
  }
};
export default reportReducer;
